import { useContext, useMemo } from 'react'
import useUser from '../contexts/hooks/useUser'
import { ObjectContext } from '../contexts/objectContext/ObjectContext'
import { trpc } from '../modules/trpc'

export const useInvoices = () => {
	const { user } = useUser()

	const object = useContext(ObjectContext)

	const { data: userByPid, isLoading: userByPidLoading } = trpc.synerall.userByPid.useQuery(
		{ personalId: user!.personalId! },
		{
			enabled: !!user && !!user.personalId,
		}
	)

	const { data: currentContractInvoices } = trpc.synerall.invoices.useQuery(
		{ contractId: object.synerallContractId! },
		{
			enabled: !!object.synerallContractId,
		}
	)

	const {
		data: allInvoiceData,
		isFetching: allInvoicesLoading,
		refetch: fetchOldInvoices,
	} = trpc.synerall.getPastInvoices.useQuery(
		{ customerId: userByPid?.Id ?? 0 },
		{
			enabled: false,
			staleTime: Infinity,
			cacheTime: 1000 * 60 * 60,
		}
	)

	const invoices = useMemo(() => {
		const paid: typeof currentContractInvoices = []
		const unpaid: typeof currentContractInvoices = []

		if (!currentContractInvoices) {
			return { paid, unpaid }
		}

		for (const invoice of currentContractInvoices) {
			if (invoice.Balance > 0) {
				unpaid.push(invoice)
			} else {
				paid.push(invoice)
			}
		}

		if (!allInvoiceData) {
			return { paid, unpaid }
		}

		for (const invoice of allInvoiceData) {
			if (!currentContractInvoices.some(ci => ci.Id === invoice.Id)) {
				if (invoice.Balance > 0) {
					unpaid.push(invoice)
				} else {
					paid.push(invoice)
				}
			}
		}

		return { paid, unpaid }
	}, [currentContractInvoices, allInvoiceData])

	return {
		invoices,
		isLoading: userByPidLoading || allInvoicesLoading,
		fetchOldInvoices,
	}
}
